import styled from '@emotion/styled';
import { Flex, Box, Button, useDisclosure } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import ConfirmationModal from '../../modal/ConfirmationModal';

const NavigationButtons = ({
    isPrevStepDisabled,
    isConfirmSubmitting,
    isConfirmDisabled,
    handlePreviousStep,
    openPreviousStepModal = true,
    displayFinishText = true,
}) => {
    const moveToPreviousStepModal = useDisclosure();

    const handleOpenPreviousStepModal = () => {
        if (openPreviousStepModal) {
            moveToPreviousStepModal.onOpen();
        } else {
            handlePreviousStep();
        }
    };

    return (
        <>
            <StickyButtonsWrapper>
                <Flex justifyContent="flex-end">
                    <Button
                        variant="secondary"
                        textTransform="capitalize"
                        onClick={handleOpenPreviousStepModal}
                        isDisabled={isPrevStepDisabled}
                        ml={5}
                    >
                        <FormattedMessage id="common_previous_step" />
                    </Button>
                    <Button
                        type="submit"
                        textTransform="capitalize"
                        ml={5}
                        isDisabled={isConfirmDisabled}
                        isLoading={isConfirmSubmitting}
                    >
                        {displayFinishText ? (
                            <FormattedMessage id="common_finish" />
                        ) : (
                            <FormattedMessage id="common_continue" />
                        )}
                    </Button>
                </Flex>
            </StickyButtonsWrapper>

            {moveToPreviousStepModal.isOpen && (
                <ConfirmationModal
                    isOpen
                    onClose={moveToPreviousStepModal.onClose}
                    header={<FormattedMessage id="item_creation_wizard_return_to_previous_step_heading" />}
                    hasExtraStep
                    content={<FormattedMessage id="common_confirmation_explanation" />}
                    confirmText={
                        <Box as="span" textTransform="capitalize">
                            <FormattedMessage id="common_continue" />
                        </Box>
                    }
                    onConfirm={() => {
                        moveToPreviousStepModal.onClose();
                        handlePreviousStep();
                    }}
                />
            )}
        </>
    );
};

const StickyButtonsWrapper = styled(Box)`
    width: 100%;
    position: fixed;
    bottom: 40px;
    min-height: 60px;
    background: var(--chakra-colors-background-tertiary);
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-top: 1px solid var(--chakra-colors-border-secondary);
    justify-content: flex-end;
    padding-right: 24px;
`;

export default NavigationButtons;
